export const NG_PLATFORM = 'sansaar-frontend';

export const API_HOST = process.env.API_HOST || 'http://localhost:5000';
export const LOCALSTORAGE_JWT_KEY = 'jwtToken';